module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ФИО",
      "required": ""
    },
    model: {
      value: (_vm.Profile.FIO),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "FIO", $$v)
      },
      expression: "Profile.FIO"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "label": "Телефон"
    },
    model: {
      value: (_vm.Profile.phone),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "phone", $$v)
      },
      expression: "Profile.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "readonly": ""
    },
    model: {
      value: (_vm.Profile.email),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "email", $$v)
      },
      expression: "Profile.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Город"
    },
    model: {
      value: (_vm.Profile.city),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "city", $$v)
      },
      expression: "Profile.city"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Адрес"
    },
    model: {
      value: (_vm.Profile.address),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "address", $$v)
      },
      expression: "Profile.address"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Данные паспорта"
    },
    model: {
      value: (_vm.Profile.passport),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "passport", $$v)
      },
      expression: "Profile.passport"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "orange"
    },
    on: {
      "click": function($event) {
        return _vm.updateProfile()
      }
    }
  }, [_vm._v("Обновить данные")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "bottom": false,
      "right": true,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Закрыть")])], 1), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-569211f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/UpdateProfile.vue
// module id = 465
// module chunks = 1